import { createSelector } from 'reselect';
import { DOMAIN_NAME } from './common';

const root = (s) => s[DOMAIN_NAME];

export const teamsSelector = createSelector(root, (s) => s.teams);
export const loadingSelector = createSelector(root, (s) => s.loading);
export const errorSelector = createSelector(root, (s) => s.error);
export const detailSelector = createSelector(root, (s) => s.detail);
export const detailLoadingSelector = createSelector(root, (s) => s.detailLoading);

// Section selectors so unrelated sections do not re-render when one section changes.
export const teamMembersSelector = createSelector(detailSelector, (d) => (d && d.members) || []);
export const teamClientsSelector = createSelector(detailSelector, (d) => (d && d.clients) || []);

export const lastCreatedTeamIdSelector = createSelector(root, (s) => s.lastCreatedTeamId);
export const paginationSelector = createSelector(root, (s) => s.pagination);
export const filtersSelector = createSelector(root, (s) => s.filters);
export const sortSelector = createSelector(root, (s) => s.sort);
export const selectedTeamSelector = createSelector(root, (s) => s.selectedTeam);
export const isTeamDialogOpenSelector = createSelector(root, (s) => s.isTeamDialogOpen);
export const isDeleteDialogOpenSelector = createSelector(root, (s) => s.isDeleteDialogOpen);
export const isDetailDialogOpenSelector = createSelector(root, (s) => s.isDetailDialogOpen);
export const totalPagesSelector = createSelector(paginationSelector, (p) =>
    Math.ceil((p.total || 0) / (p.limit || 10)) || 1
);

export const employeeOptionsSelector = createSelector(root, (s) => s.employeeOptions);
export const employeeOptionsLoadingSelector = createSelector(root, (s) => s.employeeOptionsLoading);
